export function render({ node, api }) {
  const root = document.createElement('div');

  const header = document.createElement('div');
  header.className = 'ew-node-header';
  header.dataset.ewDrag = 'true';
  header.dataset.ewSelect = 'true';
  header.dataset.ewLink = 'true';

  const title = document.createElement('span');
  title.textContent = node.props?.title || 'Datetime Input';

  const anchor = document.createElement('span');
  anchor.className = 'ew-link-anchor';
  anchor.dataset.ewLink = 'true';
  anchor.title = 'Link';

  header.append(title, anchor);

  const body = document.createElement('div');
  body.className = 'ew-node-body';

  const label = document.createElement('label');
  label.textContent = node.props?.label || 'Select date/time';

  const input = document.createElement('input');
  input.type = 'datetime-local';
  input.value = node.data?.value || node.props?.value || '';
  if (node.props?.min) input.min = node.props.min;
  if (node.props?.max) input.max = node.props.max;
  if (node.props?.step) input.step = String(node.props.step);

  const onChange = () => {
    api.setData({ value: input.value });
    api.emit('node:input', { id: node.id, field: 'value', value: input.value });
  };

  input.addEventListener('change', onChange);
  input.addEventListener('input', onChange);

  body.append(label, input);
  root.append(header, body);

  return {
    el: root,
    update: (next) => {
      title.textContent = next.props?.title || 'Datetime Input';
      label.textContent = next.props?.label || 'Select date/time';
      input.min = next.props?.min || '';
      input.max = next.props?.max || '';
      input.step = next.props?.step ? String(next.props.step) : '';
      const nextValue = next.data?.value || next.props?.value || '';
      if (input.value !== nextValue) input.value = nextValue;
    },
    cleanup: () => {
      input.removeEventListener('change', onChange);
      input.removeEventListener('input', onChange);
    }
  };
}
